// components/NavBar.jsx
import './NavBar.css';
import React, { useState, useEffect, useRef } from 'react';
import { NavLink } from 'react-router-dom';
import logoImage from '../assets/Links/Shrivel_Logo.png';
import fbLogo from '../assets/Links/FB_Logo.png';
import instaLogo from '../assets/Links/Insta_Logo.png';

const NavBar = () => {
  const [isMenuOpen, setMenuOpen] = useState(false);
  const menuRef = useRef(null); // Ref for menu container
  const buttonRef = useRef(null); // Ref for the toggle button

  const toggleMenu = () => setMenuOpen(prev => !prev);

  useEffect(() => {
    const handleClickOutside = (event) => {
      // If click is outside both menu and button, close the menu
      if (
        menuRef.current &&
        !menuRef.current.contains(event.target) &&
        buttonRef.current &&
        !buttonRef.current.contains(event.target)
      ) {
        setMenuOpen(false);
      }
    };

    document.addEventListener('mousedown', handleClickOutside);
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, []);

  return (
    <div className="nav-wrapper">
      {/* Mobile Nav */}
      <div className="hero-mobile">
        <header className="top-layer">
          <div className="logo-container">
            <img src={logoImage} alt="Logo" />
          </div>
          <button
            className="nav-trigger js-nav-trigger"
            onClick={toggleMenu}
            ref={buttonRef}
          >
            <span className="nav-icon"></span>
          </button>

          {isMenuOpen && (
            <nav className="mobile-menu" ref={menuRef}>
              <ul className="nav-links-mobile">
                <li><NavLink to="/" end>Home</NavLink></li>
                <li><NavLink to="/about">About</NavLink></li>
                <li><NavLink to="/products">Products</NavLink></li>
                <li><NavLink to="/process">Process</NavLink></li>
                <li><NavLink to="/contact">Contact</NavLink></li>
                <li>
                  <a href="https://www.facebook.com/people/Butler-Rice/61577965940452/" target="_blank" rel="noopener noreferrer">
                    <img src={fbLogo} alt="Facebook" style={{ height: '1.5rem', verticalAlign: 'middle' }} />
                  </a>
                </li>
                <li>
                  <a href="https://www.instagram.com/butler_rice_brand/" target="_blank" rel="noopener noreferrer">
                    <img src={instaLogo} alt="Instagram" style={{ height: '1.5rem', verticalAlign: 'middle' }} />
                  </a>
                </li>
              </ul>
            </nav>
          )}
        </header>
      </div>

      {/* Desktop Nav */}
      <div className="hero-section">
        <nav className="nav-bar">
          <div className="logo-container">
            <img src={logoImage} alt="Logo" />
          </div>
          <ul className="nav-links">
            <li><NavLink to="/" end>Home</NavLink></li>
            <li><NavLink to="/about">About</NavLink></li>
            <li><NavLink to="/products">Products</NavLink></li>
            <li><NavLink to="/process">Process</NavLink></li>
            <li><NavLink to="/contact">Contact</NavLink></li>
            <li>
              <a href="https://www.facebook.com/people/Butler-Rice/61577965940452/" target="_blank" rel="noopener noreferrer">
                <img src={fbLogo} alt="Facebook" style={{ height: '1.5rem', verticalAlign: 'middle' }} />
              </a>
            </li>
            <li>
              <a href="https://www.instagram.com/butler_rice_brand/" target="_blank" rel="noopener noreferrer">
                <img src={instaLogo} alt="Instagram" style={{ height: '1.5rem', verticalAlign: 'middle' }} />
              </a>
            </li>
          </ul>
        </nav>
      </div>
    </div>
  );
};

export default NavBar;